// WebSocketContext.js
import React, {createContext, useState, useEffect, useContext, useRef} from 'react';
import WebSocketService from '../../websockets/WebSocketService';


const QuoteContext = createContext();

export const useQuoteContext = () => useContext(QuoteContext);

export const QuoteProvider = ({ instrumentToken, uniqueId, children }) => {
    const [Quote, setQuote] = useState({});
    let closePrice = useRef(null);  // Use ref to hold closePrice without causing re-renders
    const [tick, setTick] = useState({});


    useEffect(() => {
        const handleQuoteUpdate = (message) => {
            if (message.type === 'SSQ' && message.data.instrumentToken === instrumentToken) {
                /*console.log('Quote Data: ', message.data);*/
                const quoteData = message.data;
                setQuote(quoteData);
                closePrice.current=quoteData.ohlc.close;
                const tickData = {
                    instrumentToken: quoteData.instrumentToken,
                    lastTradedPrice: quoteData.lastPrice,
                    lastTradedQuantity: quoteData.lastTradedQuantity,
                    lastTradedTime: quoteData.lastTradedTime,
                    change: quoteData.change,
                    oi: quoteData.oi,
                    totalSellQuantity: quoteData.sellQuantity,
                    totalBuyQuantity: quoteData.buyQuantity,
                    volumeTradedToday: quoteData.volumeTradedToday,
                    openPrice: quoteData.ohlc.open,
                    closePrice: quoteData.ohlc.close,
                    lowPrice: quoteData.ohlc.low,
                    highPrice: quoteData.ohlc.high,
                    depth: {
                        buy: quoteData.depth.buy.map(b => ({
                            price: b.price,
                            quantity: b.quantity,
                            orders: b.orders
                        })),
                        sell: quoteData.depth.sell.map(s => ({
                            price: s.price,
                            quantity: s.quantity,
                            orders: s.orders
                        }))
                    },
                    lowerCircuitLimit: quoteData.depth.lowerCircuitLimit,
                    upperCircuitLimit: quoteData.depth.upperCircuitLimit,
                    tickTimestamp: quoteData.timestamp,
                    averageTradedPrice: quoteData.averagePrice,
                    oiDayHigh: quoteData.oiDayHigh,
                    oiDayLow: quoteData.oiDayLow,
                };
                setTick(tickData);
            }
        };

        // Log the subscription with uniqueId
        /*if(instrumentToken===36865){
            console.log(`Subscribing to WebSocket for instrumentToken: ${instrumentToken}, uniqueId: ${uniqueId}`);
        }*/
        WebSocketService.subscribe('SSQ', instrumentToken, handleQuoteUpdate);

        return () => {
            // Log the unsubscription with uniqueId
            /*if(instrumentToken===36865) {
                console.log(`Unsubscribing from WebSocket for instrumentToken: ${instrumentToken}, uniqueId: ${uniqueId}`);
            }*/
            WebSocketService.unsubscribe('SSQ', instrumentToken, handleQuoteUpdate);
        };
    }, [instrumentToken]); // Add uniqueId as a dependency

    return (
        <QuoteContext.Provider value={{ Quote, closePrice: closePrice.current,tick }}> {/* Provide closePrice as current value */}
            {children}
        </QuoteContext.Provider>
    );
};

